import axios from "axios";
import { getSessionId } from "../../../../utils/tokenHandlers";
import UidEmailRoleMatch from "../../../constants/uidEmailRoleMatch";

export const getUploadedDocs = (customerId: number) => {
  const UidEmailRole = UidEmailRoleMatch();

  const sessionid = getSessionId();
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/read/many/tradexwbench.customer_kyc_document/`,
      {
        params: {
          ...UidEmailRole,
          filter: `[('customer_id','in',[${customerId}]), ('customer_key_person_id', '=', False)]`,
          query:
            "{id, document_type,document_name, document_name_fgn ,customer_id,document_name_text,attachment_ids,customer_key_person_id, maker_verification_attachment_status, maker_verification_attachment_ids, maker_verification_attachment_comments,maker_verification_status, checker_verification_status}",
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionid}`,
        },
      }
    )
    .then((response) => {
      //  // console.warn(customerId);
      return response;
    })
    .catch((err) => err);
};
